import  { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from '../ConstantsEN';
import { Period_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import { PeriodTable } from './Tables';
import { PeriodLengthSelect, CycleLengthComponent } from './Component';
import SharedHelmet from "../Helmet";
const TITLE = 'Period Calculator and Ovulation Days - A Comprehensive Guide to Women\'s Health';
const DESCRIPTION = 'Online menstrual cycle calculator (Period Calculator) helps you calculate your upcoming menstrual cycle and ovulation days in Gregorian date format. It also provides a manual method for calculating the menstrual cycle.';
const KEYWORDS = 'Period Calculator, Menstrual cycle calculator, Menstrual cycle timing, Menstrual cycle dates calculation, Menstrual cycle calendar, Period length calculation, Period calculator, Menstrual cycle analysis, Menstrual cycle date predictions, Menstrual cycle tracking, Menstrual cycle regularity, How to calculate the menstrual cycle for pregnancy, Next menstrual cycle calculation';
const OG_URL = 'https://do-calculate.com/calculator/en/period/';
const apiEndpoint = `${SERVER_URL}/${Period_EndPoint}`;
function PeriodCalculator() {
    const [firstDayOfLastPeriod, setFirstDate] = useState();
    const [periodLength, setPeriodLength] = useState(1);
    const [cycleLength, setCycleLength] = useState(28);
    const [result, setResult] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const handleDateChange = (event) => {
        setFirstDate(event.target.value)
    };
    const calculatePeriod = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ firstDayOfLastPeriod, cycleLength, periodLength }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setResult(data["result"]);
            } else {
                setResult(null);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '15px' }}>Menstrual Cycle Calculator - Calculate Menstrual Cycle and Ovulation Days</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                Use this calculator to calculate your menstrual cycle and estimate the number of your upcoming menstrual cycle days or the most probable ovulation days.
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className='col-12 col-md-5 calculatorStyle'>
                                <div className='p-3 mb-2 bg-success text-white'>
                                    Period Calculator
                                </div>
                                <hr />
                                <br />
                                <div className=" form-group d-flex align-items-center">
                                    <b>  <label htmlFor="firstDate" className="form-label ms-2" >
                                        <strong>First day</strong> of your last period
                                    </label>
                                    </b>
                                    <br />
                                    <input
                                        type="date"
                                        id="firstDate"
                                        value={firstDayOfLastPeriod}
                                        onChange={handleDateChange}
                                        className="form-control ml-2"
                                        style={{ width: '145px' }}
                                        placeholder="175"
                                    />
                                </div>
                                <br />
                                <div className=" form-group d-flex align-items-center">
                                    <b>  <label htmlFor="PeriodLength" className="form-label ms-2" >
                                        How long did it last?
                                    </label>
                                    </b>
                                    <PeriodLengthSelect handleDateChange={setPeriodLength} />
                                    <div className="input-group-append">
                                        <span className="input-group-text ">days</span>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>  <label htmlFor="CycleLength" className="form-label ms-2">
                                        Average time between cycles
                                    </label>
                                    </b>
                                    <CycleLengthComponent handleDateChange={setCycleLength} />
                                    <div className="input-group-append">
                                        <span className="input-group-text ">days</span>
                                    </div>
                                </div>
                                <br />
                                <hr />
                                <div>
                                    <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={calculatePeriod} disabled={isLoading}>
                                        {isLoading ? (
                                            <div className="spinner-border spinner-border-sm" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        ) : (
                                            'Calculate'
                                        )}
                                    </button>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u>Error:</u></b> Please enter all fields correctly.</div>}
                                {result &&
                                    (
                                        <div>
                                            <h4><div className="p-3 mb-2 bg-success text-white">Results: </div></h4>
                                            <hr />
                                            <PeriodTable result={result}></PeriodTable>
                                        </div>
                                    )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.womenCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Menstruation: Understanding the Process and How to Calculate it</div>
                            <div className="info-section-body">
                                <u><h2 style={{ fontSize: '16px' }}>Menstruation: Understanding the Process and How to Calculate it</h2></u>
                                <p>
                                    Menstruation is a natural process that occurs in a woman's body typically every month and refers to the monthly bleeding that occurs due to the absence of pregnancy. This process is important for a woman's health and serves as an indication that the reproductive system is functioning properly. In this article, we will take a look at menstruation, how to calculate it, and various related concepts.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>Understanding Menstruation:</h2></u>
                                <p>
                                    Menstruation is a process in the reproductive system that involves the renewal and shedding of the uterine lining. Menstruation usually begins in girls during adolescence and continues until menopause. Menstruation is characterized by the shedding of a certain amount of blood and tissues from the uterus through the vagina, known as menstruation.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>How to Calculate Menstruation:</h2></u>
                                Menstruation can be calculated based on several factors, including:
                                <ul>
                                    <li>
                                        Menstrual Period: This is the period during which bleeding occurs. Menstrual periods can be easily tracked by recording the start and end dates.
                                    </li>
                                    <li>
                                        Cycle Length: This is the duration between the start of one cycle and the start of the next. Cycle lengths vary from woman to woman and are usually between 21 and 35 days.
                                    </li>
                                    <li>
                                        Estimating the Next Menstrual Cycle Date: Based on the average cycle length and the start date of the last period, the start date of the next menstrual cycle can be estimated.
                                    </li>
                                    <li>
                                        Calendar: A calendar can be used to record the start and end dates of menstruation and cycle periods for regular tracking.
                                    </li>
                                    <li>
                                        Apps and Smart Tools: There are many apps and smart tools available for tracking menstruation and improving prediction accuracy.
                                    </li>
                                </ul>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>Importance of Menstruation:</h2></u>
                                <p>
                                    Menstruation is of great importance to women's health. It reflects hormonal balance and overall body health. If menstruation is regular and free from problems, it indicates a healthy hormonal system and regular bodily processes. However, changes or irregularities in menstruation can signal health issues that may need attention.
                                </p>
                                <hr />
                            </div>
                        </div>
                    </div>
                    <br />
                    <u><h2>Frequently Asked Questions</h2></u>
                    <br />
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>Is it permissible to pray during menstruation?</h3>
                            </div>
                            <div className="info-section-body">
                                <p>
                                    It is not permissible for a woman to pray during her menstrual period. This is based on the hadith of the Prophet ﷺ to Fatimah bint Abi Hubaysh: "When your period begins, stop praying." Scholars also agree that the prayers missed during this period are not to be made up. If a woman becomes pure before the time of a prayer expires, she must perform ablution and offer that prayer.
                                </p>
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>What are the reasons for delayed menstruation?</h3>
                            </div>
                            <div className="info-section-body">
                                Many women may miss or experience delayed menstruation at times. Delayed or missed menstruation can be due to various reasons. In most cases, there is no cause for concern, but it's a good idea to consult a doctor to be sure.
                                Pregnancy is undoubtedly the most common cause of missed menstruation. However, other medical and lifestyle factors can also affect your menstrual cycle and lead to delayed menstruation, so it's a good idea to consult a doctor to rule out any issues.
                                If you are not pregnant, here are some common reasons for missed or delayed menstruation:
                                <ul>
                                    <li>Pregnancy.</li>
                                    <li>Stress.</li>
                                    <li>Onset of perimenopause (the stage before menopause), usually between the ages of 45 and 55.</li>
                                    <li>Polycystic Ovary Syndrome (PCOS).</li>
                                    <li>Sudden weight loss.</li>
                                    <li>Weight gain.</li>
                                    <li>Excessive exercise.</li>
                                    <li>Use of birth control pills.</li>
                                    <li>Breastfeeding.</li>
                                    <li>Sometimes, the timing of menstruation may vary from one cycle to another, and the cycle may come earlier or later. This is known as irregular menstruation.</li>
                                    <li>Menstruation may also stop at times due to a medical condition, such as heart disease, diabetes, or thyroid gland dysfunction.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>What are the symptoms of menstruation?</h3>
                            </div>
                            <div className="info-section-body">
                                It is common to experience pain or discomfort before or during menstruation. There are things you can do to help alleviate this pain.
                                Check if it's menstrual pain:
                                Menstrual pain often occurs in women around the beginning of their menstrual period. This pain can affect anyone with menstrual cycles.
                                You may have menstrual pain if you:
                                <ul>
                                    <li>Feel pain in the lower abdominal area at the start of your menstrual period or several days before it.</li>
                                    <li>Experience painful cramps in the lower abdominal area that extend to the back and thighs.</li>
                                    <li>Feel severe or sharp pain in the lower abdominal area.</li>
                                </ul>
                                Menstrual pain often lasts up to 3 days and can affect your daily activities.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>How can you alleviate menstrual pain?</h3>
                            </div>
                            <div className="info-section-body">
                                There are some things you can do to help alleviate menstrual pain.
                                Try the following:
                                <ul>
                                    <li>Take a warm bath or shower.</li>
                                    <li>Use a heating pad or a hot water bottle wrapped in a towel on your abdomen.</li>
                                    <li>Try massaging your abdominal and back area.</li>
                                    <li>Engage in gentle exercises like yoga, swimming, walking, or cycling.</li>
                                    <li>Use pain relievers like acetaminophen or ibuprofen.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>What is the age of menopause?</h3>
                            </div>
                            <div className="info-section-body">
                                <p>
                                    The average age at which women begin to experience menopause is 46 years old. Menstruation typically ceases by the age of 51. Some of the most common symptoms include heavy bleeding, hot flashes, night sweats, mood swings, vaginal dryness, and bladder issues.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default PeriodCalculator;
